import { render, staticRenderFns } from "./MergeEqualGoodsAdd.vue?vue&type=template&id=b260b69e&scoped=true&"
import script from "./MergeEqualGoodsAdd.vue?vue&type=script&lang=js&"
export * from "./MergeEqualGoodsAdd.vue?vue&type=script&lang=js&"
import style0 from "./MergeEqualGoodsAdd.vue?vue&type=style&index=0&id=b260b69e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b260b69e",
  null
  
)

export default component.exports